export default {
    FORGOT_PASSWORD: "user/FORGOT_PASSWORD"
}